import { inject } from '@angular/core';

import { injectTellentAppKind, ORG_GUID, TellentAdminAppConfig } from '@core/tellent-types';
import { injectTellentAppUrlBuilder } from '@core/tellent-util';

export function redirectToOneDomainIfLegacyDomainVisited(
  isOneDomainEnabled: boolean,
  appConfig: TellentAdminAppConfig,
) {
  if (!isOneDomainEnabled) {
    return false;
  }

  const isOneDomainHost = appConfig.tellentOneDomainUrl?.includes(window.location.hostname);

  if (isOneDomainHost) {
    return false;
  }

  const urlBuilder = injectTellentAppUrlBuilder();
  const appKind = injectTellentAppKind();
  const orgGuid = inject(ORG_GUID)!;
  const redirectUrl = urlBuilder(appKind, undefined, orgGuid);

  window.open(redirectUrl, '_self');

  return true;
}
